export default "__VITE_ASSET__wFXx2W1N__"